import { EstimateRow } from "../state/estimateRow";
import { CostbookRow } from "../state/costbookRow";
import { CostbookRowType } from "../state/costbookRowType";
import { FormatUtility } from "./formatUtility";
import { StringUtility } from "./stringUtility";
import { BufferItem } from "../buffer/bufferItem";
import { BufferItemType } from "../buffer/bufferItemType";
import { EstimateRowType } from "../state/estimateRowType";

export class ClipboardUtility {
    public static copyRowsToClipboard(buffer: BufferItem[]) {
        console.log('copyRowsToClipboard', buffer);

        let text = '';
        let currentTitle = undefined;
        let currentHeader = undefined;

        for (let item of buffer) {
            switch (item.type) {
                case BufferItemType.costRow:
                    let row = <CostbookRow>item.data;

                    if (row.attributes.sectionTitle && row.attributes.sectionTitle != currentTitle) {
                        text += `${row.attributes.sectionTitle}
"${row.attributes.sectionTitle}"
__________________________________________________________________________

`;
                        currentTitle = row.attributes.sectionTitle;
                    }

                    if (row.attributes.headerOptions && row.attributes.headerOptions != currentHeader) {
                        let ho = '"' + JSON.parse(row.attributes.headerOptions).slice(1).join('","') + '"';
                        text += `${ho}
__________________________________________________________________________

`;
                        currentHeader = row.attributes.headerOptions;
                    }

                    let rt = ClipboardUtility.createClipboardCostbookRow(row);
                    if(rt)
                        text += rt;

                    break;

                case BufferItemType.estimateRow:
                    let erow = <EstimateRow>item.data;
                    if (currentHeader === undefined) {
                        text += `"Qty","Craft","Hours","Unit","Material","Labor","Equipment","Total"
__________________________________________________________________________

`;
                        currentHeader = 'header';
                    }

                    let ert = ClipboardUtility.createClipboardEstimateRow(erow);
                    if (ert)
                        text += ert;

                    break;
                default:
                    throw new TypeError(`bufferitemtype unknown  ${item.type}`);
                    break;
            }
        }

        if (text)
            ClipboardUtility.copyTextToClipboard(text);
    }

    static createClipboardEstimateRow(erow: EstimateRow): string {
        console.log('createClipboardEstimateRow', erow);

        let text = '';

        switch (erow.type) {
            case EstimateRowType.text:
                text = `"${StringUtility.removeTags(erow.attributes.text)!}"
`;
                break;
            case EstimateRowType.cost:
                //1.00, "B2", .1150, "SF", 2.17, 4.01, 0.00, 6.18
                text =
                    `${erow.attributes.quantity},"${erow.attributes.craftCode ? erow.attributes.craftCode : '--'}",${erow.attributes.totalManHours},"${erow.attributes.unitOfMeasure}",${FormatUtility.formatPrice(erow.attributes.totalMaterial)},${FormatUtility.formatPrice(erow.attributes.totalLabor)},${FormatUtility.formatPrice(erow.attributes.totalEquipment)}, ${FormatUtility.formatPrice(erow.attributes.totalTotal)}

`;
                break;
            case EstimateRowType.subtotal:
                //"**Subtotal: ASDASDASD"
                //"","",0.2,"",4.80,7.85,0.00,12.65
                text =
                    `"** Subtotal: ${erow.attributes.text}"
"","",${erow.attributes.totalManHours},"",${FormatUtility.formatPrice(erow.attributes.totalMaterial)},${FormatUtility.formatPrice(erow.attributes.totalLabor)},${FormatUtility.formatPrice(erow.attributes.totalEquipment)},${FormatUtility.formatPrice(erow.attributes.total)}

`;
                break;
        }

        return text;
    }

    static createClipboardCostbookRow(row: CostbookRow): string {
        let text = '';
        switch (row.type) {
            case CostbookRowType.text:
                text = StringUtility.removeTags(row.attributes.text)!;
                break;
            case CostbookRowType.aggregateCostMLET:
            case CostbookRowType.aggregateCost:
            case CostbookRowType.purchaseCost:
                text = "${row.attributes.name}	${row.attributes.crew ? row.attributes.crew:'--'}@${row.attributes.hours}	${row.attributes.unitOfMeasure}	${FormatUtility.formatPrice(row.attributes.materialPrice)}	${FormatUtility.formatPrice(row.attributes.laborPrice)}	${FormatUtility.formatPrice(row.attributes.totalPrice)}\n\n";
                break;
            case CostbookRowType.materialCost:
                if (row.attributes.prices)
                    text = "${row.attributes.name}	${row.attributes.unitOfMeasure}	${(JSON.parse(row.attributes.prices)).map((x:number) => { return FormatUtility.formatPrice(x)}).join('\t')}\n\n";
                break;
            case CostbookRowType.equipmentCost:
                text = "${row.attributes.equipment}	${FormatUtility.formatPrice(row.attributes.dayPrice)}	${FormatUtility.formatPrice(row.attributes.weekPrice)}	${FormatUtility.formatPrice(row.attributes.monthPrice)}\n\n";
                break;
            case CostbookRowType.customCost:
                if (row.attributes.costs)
                    text = "${row.attributes.name}	${row.attributes.unitOfMeasure}	${(JSON.parse(row.attributes.costs)).map((x: number) => { return FormatUtility.formatPrice(x) }).join('\t')}\n\n";
        }
        return text;
    }


    public static copyTextToClipboard(text?: string) {
        console.log('copyTextToClipboard', text);

        if (!text)
            return;

        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/utilities/clipboardUtility.ts